import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconSpeaker",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(a, r, l, p, f, e) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--speaker"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Speaker",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...r[0] || (r[0] = [
    i("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3 1.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H3ZM1.5 2A1.5 1.5 0 0 1 3 .5h6A1.5 1.5 0 0 1 10.5 2v8A1.5 1.5 0 0 1 9 11.5H3A1.5 1.5 0 0 1 1.5 10V2Z",
      "clip-rule": "evenodd"
    }, null, -1),
    i("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM3.5 7a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm2-4a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const S = /* @__PURE__ */ s(c, [["render", m]]);
export {
  S as default
};
//# sourceMappingURL=speaker.js.map
